<ion-header>
  <ion-toolbar>
    <ion-title>Make a Donation</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <curbnturf-donation (close)="onCloseModal()" [confirmationCode]="confirmationCode" [poi]="poi" [boondockSite]="boondockSite">
  </curbnturf-donation>
</ion-content>
